// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, number, string } from 'prop-types'

class CustomSuggestionRender extends React.Component {
  static propTypes = {
    siteId: number.isRequired,
    siteName: string.isRequired,
    SuggestionDetails: func.isRequired,
  }

  state = {
    top: '0',
  }

  componentDidMount () {
    // this is the <ul /> that wraps the selections
    this.parentNode = this.selectionNode.offsetParent.children[0]
  }

  getScrollTop = () => ({
    top: `${this.selectionNode.offsetTop - this.parentNode.scrollTop}px`,
  })

  setOffsetTop = e => {
    // get the difference of the parentNode's scrollTop and the selectionNode's offsetTop
    // to calculate the placement of the suggestion details element.
    // NOTE: do not tweak the position property of these elements.
    // Neither here nor in the SCSS. This will likely cause the
    // <SuggestionDetails /> to no longer display properly.
    // NOTE: If you need to change the layout of this element,
    // target children of <SuggestionDetails /> with the necessary styles.
    this.setState(() => this.getScrollTop())
  }

  render () {
    const {
      props: { siteId, siteName, SuggestionDetails },
      setOffsetTop,
      state: { top },
    } = this

    return (
      <div
        className={'suggestion-site-with-details suggestion-element main-font'}
        data-key={siteId}
        onMouseEnter={setOffsetTop}
        ref={n => { this.selectionNode = n }}>
        {siteName}
        <SuggestionDetails {...this.props} top={top} />
      </div>
    )
  }
}

export default CustomSuggestionRender
